import CheckboxComponent from './checkbox.component'

const CheckboxModule = angular.module('cdbl.checkbox', [

])
  .component('cdblCheckbox', CheckboxComponent)
  .name

export default CheckboxModule
